import type { Initiative } from '../../../../../api/initiative-client/initiative-client.type';
import { TargetComparison, type Target } from '../../../../../api/targets-client/targets-client.type';
import { TimeAllocationType } from '../../../../../api/work-periods-client/work-periods-client.type';

/**
 * Generates initial data for the target modal based on an initiative
 *
 * @param {Initiative} initiative - The initiative to generate initial data from
 * @returns {Partial<Target>} The initial data for the target modal
 */
const getTargetModalInitialData = (initiative: Initiative): Partial<Target> => {
  return {
    initiatives: [
      {
        id: initiative.id,
        name: initiative.name,
        start_date: initiative.start_date ? new Date(initiative.start_date).toISOString() : '',
        end_date: initiative.end_date ? new Date(initiative.end_date).toISOString() : '',
      },
    ],
    start_date: initiative.start_date,
    end_date: initiative.end_date,
    time_allocation_type: TimeAllocationType.BiWeekly,
    target_comparison: TargetComparison.EQ,
    use_transform: true,
  };
};

export { getTargetModalInitialData };
